import Vue from "vue";
/**
 * Font Awesome Icon Definitions
 */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCog,
  faExternalLinkAlt,
  faSave,
  faSort,
  faSpinner,
  faPen,
  faEdit,
  faTimes,
  faTrash,
  faPlus,
  faFlag,
  faInfoCircle,
  faCompress,
  faExpand,
  faSubscript,
  faSuperscript,
  faUndoAlt,
  faKey,
  faQuestion,
  faSitemap
} from "@fortawesome/free-solid-svg-icons";

/**
 * Global Definitions
 */
import Badge from "@/components/global/Badge.vue";
import Button from "@/components/global/Button.vue";
import ButtonIcon from "@/components/global/ButtonIcon.vue";
import Dialog from "@/components/global/Dialog.vue";
import DisplayLabel from "@/components/global/DisplayLabel.vue";
import Utility from "@/components/global/Utility.vue";
import Radio from "@/components/global/Radio.vue";
import RadioGroup from "@/components/global/RadioGroup.vue";

/**
 * Add Icons to Font Library
 * Only these will get used rest of library is disregarded.
 */
library.add(
  faCog,
  faExternalLinkAlt,
  faSave,
  faSpinner,
  faSort,
  faPen,
  faKey,
  faTimes,
  faTrash,
  faQuestion,
  faSitemap,
  faCompress,
  faExpand,
  faPlus,
  faFlag,
  faEdit,
  faInfoCircle,
  faSubscript,
  faSuperscript,
  faUndoAlt
);

/**
 * Global Definitions
 * Local Components Which we have control off.
 */
Vue.component("q-badge", Badge);
Vue.component("q-button", Button);
Vue.component("q-button-icon", ButtonIcon);
Vue.component("q-dialog", Dialog);
Vue.component("q-display-label", DisplayLabel);
Vue.component("q-utility", Utility);
Vue.component("q-radio", Radio);
Vue.component("q-radio-group", RadioGroup);
Vue.component("q-icon", FontAwesomeIcon);

export default {};
